import React from 'react';

import {MainText, Link, RedBoldTitle} from './Fraud.style';

function FraudNoticeContent() {
  return (
    <>
      <RedBoldTitle>
        Important Notice to Suppliers - Fraud Prevention May 2026
      </RedBoldTitle>
      <MainText bold={true}>
        Important Notice Regarding Fraudulent Communications
      </MainText>
      <MainText>
        It has come to our attention that fraudsters are impersonating JJ Food
        Service Limited in an attempt to obtain goods and services fraudulently
        in our name.
      </MainText>
      <MainText>
        We are aware that false email addresses are being used and strongly
        advise that you do not respond to any suspicious communications under
        any circumstances.
      </MainText>
      <MainText>
        Please note that all official communications from JJ Food Service
        Limited will only be sent from email addresses ending
        in <strong>@jjfoodservice.com</strong>.
      </MainText>
      <MainText>
        We also ask that you ensure you are communicating with an authorised
        representative of JJ Food Service Limited when discussing any
        agreements, orders, or arrangements between JJ Food Service and your
        organisation as a supplier.
      </MainText>
      <MainText bold={true}>
        We will not accept any liability for goods or services supplied to
        addresses that are not listed on our official website.
      </MainText>
      <MainText bold={true}>Please note:</MainText>
      <ul>
        <li>
          JJ Food Service will never place orders without a period of
          negotiation.
        </li>
        <li>
          A formal trading agreement will always be issued before trading
          commences, including requests for product details and supporting
          documentation.
        </li>
        <li>
          Goods should never be dispatched to addresses other than our
          published distribution sites unless written confirmation is received
          from your usual JJ contact.
        </li>
        <li>
          Orders must not be dispatched until formal confirmation has been
          received through the recognised booking-in procedure provided by the
          JJ Purchasing team.
        </li>
      </ul>
      <MainText bold={true}>
        Please remain vigilant and contact us directly if you have any concerns
        regarding suspicious activity.
      </MainText>
      <MainText bold={true}>Contact: 00 44 1992 701710</MainText>
      <MainText>Please refer to the branch list at the link below:</MainText>
      <Link
        href={'https://www.jjfoodservice.com/branchLocator/'}
        target="_blank"
        rel="noopener noreferrer"
      >
        Link for the Branch List.
      </Link>
      <MainText>
        No other location should be considered an authorised delivery point for
        JJ Food Service Limited.
      </MainText>
    </>
  );
}

export default FraudNoticeContent;
